(function($) {

	'use strict';

	var init = function() {

		openMenu();
		openSubMenu();

	};

	var openMenu = function() {

		$('.header-tools__burger').click(function() {
			$(this).toggleClass('active');
			$('.header-nav').toggleClass('active');
			$('.header-tools__lang-mobile').toggleClass('active');
			$('body').toggleClass('open');
		})
	}

	var openSubMenu = function() {
		$('.header-nav__n1__item').click(function(event) {
			$('.header-nav__n2').not(this).removeClass('header-nav__n2__open');
			$(this).children('.header-nav__n2').toggleClass('header-nav__n2__open');
		});
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
